import { render, staticRenderFns } from "./HPButton.vue?vue&type=template&id=f304d1dc&scoped=true&"
import script from "./HPButton.vue?vue&type=script&lang=js&"
export * from "./HPButton.vue?vue&type=script&lang=js&"
import style0 from "./HPButton.vue?vue&type=style&index=0&id=f304d1dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f304d1dc",
  null
  
)

export default component.exports